import { cn } from 'src/utils/cn'

const sizeVariants = {
  small:
    'rounded-5 px-[12px] py-[2px] text-body-x-small lg:rounded-8 lg:py-[7px] lg:text-body-small',
  large:
    'rounded-13 px-[12px] py-[5px] text-body-x-small lg:rounded-20 lg:py-[10px] lg:px-[16px] lg:text-body-small',
}

const colors = {
  blue: 'bg-[#154198]',
  darkBlue: 'bg-[#142e57]',
  green: 'bg-[#1ca568]',
  orange: 'bg-[#eb9500]',
}

const HeroBubble = ({
  className = '',
  text = '',
  variant = 'small',
  color = 'darkBlue',
  position = 'relative',
  placement = {},
}) => {
  return (
    <div
      className={cn(position, sizeVariants[variant], colors[color], className)}
      style={{ ...placement }}
    >
      <p className="text-white">{text}</p>
    </div>
  )
}

export default HeroBubble
